import { render, staticRenderFns } from "./new8.vue?vue&type=template&id=b7ea6480&scoped=true&"
import script from "./new8.vue?vue&type=script&lang=js&"
export * from "./new8.vue?vue&type=script&lang=js&"
import style0 from "./new8.vue?vue&type=style&index=0&id=b7ea6480&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7ea6480",
  null
  
)

export default component.exports